module.exports = __webpack_public_path__ + "static/media/companyHeaderImg.db64e8d7.png";